import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'

import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {BaseRequest, FileMimeType, KeyValuePair, Utils} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'
import {Action} from 'vuex-class'


@Component({})
export default class CreditIndicationComponent extends AfterFetchComponent {

  @Action('fetchMemberLoanRating', StoreNamespace.CREDIT) fetchMemberLoanRating: any
  @Action('downloadLoanRatingType', StoreNamespace.CREDIT) downloadLoanRatingType: any
  @Action('getAllRatingOptions', StoreNamespace.CREDIT) getAllRatingOptions: any
  @Action('exportLoanRatingDetails', StoreNamespace.CREDIT) exportLoanRatingDetails: any
  @Action('downloadAllBySearchObject', StoreNamespace.CREDIT) downloadAllBySearchObject: any
  @Action('downloadAllLoanRatingType', StoreNamespace.CREDIT) downloadAllLoanRatingType: any

  private searchLoansFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []
  private allRatingType: KeyValuePair[] = [];
  private showFileNotExistErrorPopup: boolean = false;
  private showDownloadAllBySearchObject: boolean = false;
  private ExportType = ExportType
  private gridData: any = [];
  private searchObject: any;
  private checkBoxCheckAllProperty = false;
  private requestCompleted: KeyValuePair[] = []
  private pageNumber: number = 0;
  private resultCount: number = 0;

  mounted() {
    this.requestCompleted = [
      {value: "true", description: "כן"},
      {value: "false", description: "לא"}];
    this.getAllRatingOptions({requestorCallback: this})
    this.initColumns();
  }

  private initSearchFields(): void {
    if (this.allRatingType === null || this.allRatingType.length === 0) {
      return;
    }

    this.searchLoansFields.push({
      label: 'creditIndication.idNumber',
      property: 'memberIdNum',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16,
      advancedOnly: false,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'creditIndication.memberName',
      property: 'memberFullName',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: false,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'creditIndication.creditIndicationStartDate',
      property: 'ratingDateCreated',
      fieldType: FieldType.DATE_FIELD,
      bootstrapColumn: 3
    })

    this.searchLoansFields.push({
      label: 'creditIndication.untilCreditIndicationStartDate',
      property: 'ratingDateEnd',
      fieldType: FieldType.DATE_FIELD,
      bootstrapColumn: 3
    })

    this.searchLoansFields.push({
      label: 'creditIndication.rating',
      property: 'ratingType',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.allRatingType,
      unSelectFirst: true,
      advancedOnly: true,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'creditIndication.requestCompleted',
      property: 'isRequestCompleted',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.requestCompleted,
      unSelectFirst: true,
      bootstrapColumn: 3,
      advancedOnly: true,
    })
  }

  private initKeyValue(arrayToFill: KeyValuePair[], data: any[]): void {
    for (const element of data) {
      arrayToFill.push({
        value: element.key,
        description: element.value
      })
    }
  }

  private initColumns(): void {
    this.columns.push({property: 'memberIdNum', header: 'creditIndication.idNumber'} as GridColumn)
    this.columns.push({property: 'memberFullName', header: 'creditIndication.memberName'} as GridColumn)
    this.columns.push({property: 'ratingDateCreated', header: 'creditIndication.creditIndicationStartDate'} as GridColumn)
    this.columns.push({property: 'ratingDateEnd', header: 'creditIndication.creditIndicationEndDate'} as GridColumn)
    this.columns.push({
      property: 'ratingType.value',
      header: 'creditIndication.rating',
      hideSorting: true
    } as GridColumn)
    this.columns.push({
      property: 'requestCompleted',
      header: 'creditIndication.requestCompleted',
      hideSorting: false
    } as GridColumn)
  }

  private getGridData(searchObject: any): void {
     this.pageNumber = searchObject.pageNumber;
    this.searchObject = searchObject;

    this.fetchMemberLoanRating({
      requestorCallback: this,
      requestBody: searchObject
    })
  }

  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {

      case 'fetchMemberLoanRating':
        const newDataList = data.results.map((result: any) => {
          return ({...result, isCheckBoxSelected: false});
        })
        this.resultCount = data.resultCount;

        if(this.pageNumber > 0) {
          this.gridData = this.gridData.concat(newDataList)
        }
        else {
          this.gridData = newDataList
        }
        this.bindGridData(newDataList, data.hasMore, data.resultCount)

        break

      case 'downloadLoanRatingType':
        Utils.downloadFile(data.fileData, data.fileName, FileMimeType.PDF)
        this.$emit('successExport', data)
        break

      case 'getAllRatingOptions':
        this.initKeyValue(this.allRatingType, data);
        this.initSearchFields()
        break

      case 'exportLoanRatingDetails':
        data.fileExtension = 'xlsx'
        this.$emit('successExport', data)
        break

      case 'downloadAllBySearchObject':
      case 'downloadAllLoanRatingType':
        Utils.downloadFile(data.fileData, data.fileName, FileMimeType.PDF, "zip")
    }
  }

  onExportClick(data: any) {
    this.downloadLoanRatingType({
      requestorCallback: this,
      pathVariable: data.memberIdNum
    })
  }

  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      case 'downloadLoanRatingType':
      case 'downloadAllBySearchObject':
      case 'exportLoanRatingDetails':
        this.showFileNotExistErrorPopup = true;
        this.$emit('failedExport')
        break
      default:
        this.handleOnError(messages, code, requestName)
    }
  }

  closeFileNotExistErrorPopup() {
    this.showFileNotExistErrorPopup = false;
    this.showDownloadAllBySearchObject = false;
  }

  onExportGrid(exportType: ExportType, gridColumns: Array<GridColumn>, searchObject: any): void {
    let exportColumns: GridColumn[] = []
    this.exportLoanRatingDetails({
      requestBody: {
        headerText: this.exportFileName,
        exportType: exportType,
        columnsList: exportColumns,
        searchObject: searchObject
      } as BaseRequest,
      requestorCallback: this
    })
  }

  private onCheckboxClick(checked: boolean, result: any) {
    if (!checked) {
      this.checkBoxCheckAllProperty = false;
    }

    this.gridData.forEach((row: any) => {
      if (row.id === result.id) {
        row.isCheckBoxSelected = checked;
      }
    });
  }

  private onCheckboxCheckAll(checkAll: boolean) {
    this.checkBoxCheckAllProperty = checkAll;

    this.gridData.forEach((row: any) => {
      row.isCheckBoxSelected = checkAll
    });
  }

  bindGridData(data: object[], hasMore: boolean, resultCount: number): void {
    this.$emit('successResults', {
      results: data,
      hasMore: hasMore,
      resultCount: resultCount
    });
  }

  onDownloadAllDocuments() {
    const selectedRows = this.gridData.filter((row: any) => row.isCheckBoxSelected === true).map((row: any) => row.memberIdNum)

    if(selectedRows.length === 0) {
      this.showDownloadAllBySearchObject = true;
      return;
    }

    this.downloadAllLoanRatingType({
      requestorCallback: this,
      requestBody: selectedRows
    })
  }

  get exportFileName(): string {
    return '' + this.$t('creditIndication.fileName')
  }

  private onDownloadAllBySearchObject() {
    this.showDownloadAllBySearchObject = false;

    this.downloadAllBySearchObject({
      requestorCallback: this,
      requestBody: this.searchObject
    })
  }
}
